import { useMemo } from 'react'

import { LabsFlag } from '../../../enums/labsFlag'
import { useCustomersBalanceReportFeature } from '../../../hooks/useCustomersBalanceReportFeature'
import { useExpertReportsFeature } from '../../../hooks/useExpertReportsFeature'
import { useIsExpertReportEnabled } from '../../../hooks/useIsExpertReportEnabled'
import type { ExpertReportsAvailability } from '../types/expertReportsAvailability'

export const useExpertReportsAvailability = (): ExpertReportsAvailability => {
  const { isExpertReportsEnabled } = useExpertReportsFeature()
  const { isCustomersBalanceEnabled } = useCustomersBalanceReportFeature()
  const isTrialBalanceEnabled = useIsExpertReportEnabled(LabsFlag.ExpertReportsTrialBalance)
  const isProfitAndLossEnabled = useIsExpertReportEnabled(LabsFlag.ExpertReportsProfitAndLoss)
  const isBalanceSheetEnabled = useIsExpertReportEnabled(LabsFlag.ExpertReportsBalanceSheet)
  const isVatDeclarationsEnabled = useIsExpertReportEnabled(LabsFlag.ExpertReportsVatDeclarations)

  return useMemo(
    () => ({
      isBalanceSheetEnabled,
      isCustomersBalanceEnabled,
      isProfitAndLossEnabled,
      isSuppliersBalanceEnabled: isExpertReportsEnabled,
      isTrialBalanceEnabled,
      isVatDeclarationsEnabled,
    }),
    [
      isBalanceSheetEnabled,
      isCustomersBalanceEnabled,
      isExpertReportsEnabled,
      isProfitAndLossEnabled,
      isTrialBalanceEnabled,
      isVatDeclarationsEnabled,
    ],
  )
}
